import React from 'react';
import CMSSideBar, { CMS_SIDEBAR_PAGES } from './CMSSideBar';
import styled from 'styled-components';
import {
  SIDE_NAVIGATION_WIDTH,
  RightToggleButton,
  ToggleButtonWrapper,
  PageTransition,
} from '../Navbar/SideBar';
import autoAnimate from '@formkit/auto-animate';
import { NAVBAR_HEIGHT } from '../Navbar';
import Button from '../elements/Button';

const Page = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  height: 100%;
`;

const Content = styled.div<{
  isSideNavigationOpen?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: ${({ isSideNavigationOpen }) =>
    isSideNavigationOpen
      ? `calc(100vw - ${SIDE_NAVIGATION_WIDTH}px)`
      : '100vw'};
  min-height: 0;
  padding: 0 64px;
  transition: width 300ms ease-in-out;
`;

const ViewPort = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
  overflow: hidden;
`;

const ScrollWrapper = styled.div`
  overflow-y: auto;
  display: flex;
  width: 100%;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  -ms-overflow-style: none;
  scrollbar-width: thin;
  overflow-x: hidden;
`;

const EmptyDiv = styled.div`
  min-height: 72px;
  width: 100%;
  flex-shrink: 0;
`;

export const BottomBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: ${({ theme }) => theme.colors.bgDefaultSecondary};
  border-top: 1px solid ${({ theme }) => theme.colors.bgActive};
  flex-shrink: 0;
`;

export const SmallButton = styled(Button)`
  margin-top: 0;
  border-radius: 8px;
  padding: 6px 16px;

  span {
    font-size: 12px;
  }
  i {
    font-size: 14px;
  }
`;

export default function CMSPageWrapper({
  children,
  currentPage,
  contentStyle,
  scrollStyle,
  shouldAddEmptyDiv = true,
  bottomBar,
}: {
  children: React.ReactNode;
  currentPage: CMS_SIDEBAR_PAGES;
  contentStyle?: React.CSSProperties;
  scrollStyle?: React.CSSProperties;
  shouldAddEmptyDiv?: boolean;
  bottomBar?: React.ReactNode;
}) {
  const [isNavigationOpen, setIsNavigationOpen] = React.useState(true);
  const parent = React.useRef(null);

  React.useEffect(() => {
    parent.current &&
      autoAnimate(parent.current, {
        duration: 300,
        easing: 'ease-in-out',
      });
  }, [parent]);

  return (
    <Page ref={parent}>
      {isNavigationOpen ? (
        <CMSSideBar
          onClose={() => setIsNavigationOpen(false)}
          currentPage={currentPage}
        />
      ) : (
        <ToggleButtonWrapper>
          <RightToggleButton onClick={() => setIsNavigationOpen(true)} />
        </ToggleButtonWrapper>
      )}
      <ViewPort>
        <ScrollWrapper style={scrollStyle}>
          <Content isSideNavigationOpen={isNavigationOpen} style={contentStyle}>
            <PageTransition key={currentPage}>{children}</PageTransition>
            {shouldAddEmptyDiv && <EmptyDiv />}
          </Content>
        </ScrollWrapper>
        {bottomBar}
      </ViewPort>
    </Page>
  );
}
